import React from "react";
import "./globalDirectory.css";

/**
 * Optional strip between filters and grid (e.g. bulk approvals).
 * Renders nothing when `visible` is false or when there is no title, hint, or actions.
 */
export default function GlobalDirectoryApprovalsSection({
  visible = true,
  title = "",
  hint = "",
  actions = null,
  className = "",
}) {
  if (!visible) return null;
  const hasTitle = Boolean(String(title || "").trim());
  const hasHint = Boolean(String(hint || "").trim());
  const hasText = hasTitle || hasHint;
  const hasActions = actions != null && actions !== false;
  if (!hasText && !hasActions) return null;

  const rootClass = ["gds-approvals", String(className || "").trim()]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={rootClass}>
      {hasText ? (
        <div className="gds-approvals__text">
          {hasTitle ? (
            <h4 className="gds-approvals__title">{String(title).trim()}</h4>
          ) : null}
          {hasHint ? (
            <p className="gds-approvals__hint">{String(hint).trim()}</p>
          ) : null}
        </div>
      ) : null}
      {hasActions ? (
        <div className="gds-approvals__toolbar">{actions}</div>
      ) : null}
    </div>
  );
}
